export default payload => ({
  type: 'RECOMMENDER_Q1_UPDATE_SELECTION',
  payload,
});
